/* STRAVENI — Final Theme JS */
document.addEventListener('DOMContentLoaded', function() {

  // STICKY HEADER
  const header = document.querySelector('.site-header');
  if(header) window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 40));

  // MOBILE NAV
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');
  if(hamburger && mobileNav) {
    hamburger.addEventListener('click', () => { mobileNav.classList.add('open'); document.body.style.overflow='hidden'; });
    if(mobileClose) mobileClose.addEventListener('click', () => { mobileNav.classList.remove('open'); document.body.style.overflow=''; });
  }

  // FAQ ACCORDION
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });

  // GALLERY THUMBNAILS
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if(mainImg && this.dataset.src) mainImg.src = this.dataset.src;
    });
  });
  if(thumbs.length > 0) thumbs[0].classList.add('active');

  // QUANTITY
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.closest('.qty-control').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if(this.dataset.action === 'minus') val = Math.max(1, val - 1);
      if(this.dataset.action === 'plus') val = Math.min(99, val + 1);
      input.value = val;
    });
  });

  // STICKY BUY BAR (mobile)
  const stickyBar = document.querySelector('.sticky-buy-bar');
  const addToCartBtn = document.querySelector('.add-cart-btn');
  if(stickyBar && addToCartBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(!entry.isIntersecting) stickyBar.classList.add('visible');
        else stickyBar.classList.remove('visible');
      });
    }, { threshold: 0 });
    observer.observe(addToCartBtn);
  }

  // SCROLL ANIMATIONS
  const fadeEls = document.querySelectorAll('.fade-up');
  if('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), parseInt(entry.target.dataset.delay) || 0);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    fadeEls.forEach(el => obs.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  // CART COUNT
  function updateCartCount() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(() => {});
  }
  updateCartCount();

  // ADD TO CART AJAX
  document.querySelectorAll('[data-atc-form]').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = this.querySelector('[data-atc-btn]');
      const orig = btn ? btn.textContent : '';
      if(btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(this) })
        .then(r => r.json())
        .then(() => {
          if(btn) btn.textContent = '✓ Added to Cart!';
          updateCartCount();
          setTimeout(() => { if(btn) { btn.textContent = orig; btn.disabled = false; } }, 2000);
        }).catch(() => { if(btn) { btn.textContent = orig; btn.disabled = false; } });
    });
  });

  // SMOOTH SCROLL
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if(target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // HEADER BUY BTN (show after scroll on desktop)
  window.addEventListener('scroll', function() {
    const btn = document.getElementById('header-cta');
    if(btn && window.innerWidth > 768) {
      btn.style.display = window.scrollY > 400 ? 'inline-flex' : 'none';
    }
  });

});

// PURCHASE OPTION SELECTOR
function selectOption(option) {
  ['single'].forEach(function(o) {
    const radio = document.getElementById('radio-' + o);
    const el = document.getElementById('option-' + o);
    if(el) { el.style.borderColor = 'var(--border)'; el.style.background = 'transparent'; }
    if(radio) { radio.classList.remove('selected'); }
  });

  const active = document.getElementById('option-' + option);
  const activeRadio = document.getElementById('radio-' + option);
  if(active) { active.style.borderColor = 'var(--forest)'; active.style.background = 'rgba(31,111,120,0.06)'; }
  if(activeRadio) activeRadio.classList.add('selected');

  const atcBtn = document.querySelector('[data-atc-btn]');
  const qtyInput = document.querySelector('.qty-input');
  const buyBtn = document.querySelector('.buy-btn');

  if(qtyInput) qtyInput.value = 1;
  if(atcBtn) atcBtn.textContent = '🛒 Add to Cart — Relieve My Neck';
  if(buyBtn) {
    buyBtn.style.display = 'block';
    buyBtn.textContent = '⚡ Buy Now — Fast Checkout';
    buyBtn.href = '/cart/49967173173488:1?checkout[step]=contact_information';
  }
}
